const PersonIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1329 6.13333C14.1329 4.95513 13.1778 4 11.9995 4C10.8213 4 9.86621 4.95513 9.86621 6.13333C9.86621 7.31154 10.8213 8.26667 11.9995 8.26667C13.1778 8.26667 14.1329 7.31154 14.1329 6.13333Z"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5999 20.0004H10.3999L9.33327 15.7337H8.2666V12.5337C8.2666 11.9679 8.49136 11.4253 8.89144 11.0252C9.29152 10.6252 9.83414 10.4004 10.3999 10.4004H13.5999C14.1657 10.4004 14.7084 10.6252 15.1084 11.0252C15.5085 11.4253 15.7333 11.9679 15.7333 12.5337V15.7337H14.6666L13.5999 20.0004Z"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PersonIcon;
